import React from 'react';
import BrandLogo from './BrandLogo';

export default function PendingApproval() {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-primary)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: 'var(--bg-card)', padding: '40px', borderRadius: '16px', maxWidth: '440px', textAlign: 'center', border: '1px solid var(--border-color)' }}>
        <BrandLogo height={42} showBeta style={{ marginBottom: 22 }} />
        <h1 style={{ color: 'var(--warning)', fontSize: '24px', marginBottom: '12px' }}>⏳ Approval Pending</h1>
        <p style={{ color: 'var(--text-secondary)', fontSize: '14px', lineHeight: '1.6' }}>
          Your account has been created but requires admin approval before you can access the platform.
          You'll receive access once an administrator reviews your registration.
        </p>
        <p style={{ color: 'var(--text-dim)', fontSize: '12px', marginTop: '20px' }}>
          Contact your club administrator if you need immediate access.
        </p>
        <button onClick={() => window.location.href = '/login'} style={{ marginTop: '20px', padding: '10px 24px', background: 'var(--accent)', color: 'var(--text-on-accent)', border: 'none', borderRadius: '8px', fontSize: '14px', cursor: 'pointer', fontWeight: 600 }}>
          Back to Login
        </button>
      </div>
    </div>
  );
}
